// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1pMwN","rotate":"Loader_rotate__3Ikph","dash":"Loader_dash__3Ko6Q"};